export const initiativeTabs = {
  overview: 'overview',
  discussion: 'discussion',
  events: 'events',
} as const
